import React from "react";
import styles from "./navigation.module.css";

export const Container = ({ children }) => {
  const [left, right] = React.Children.toArray(children);
  return (
    <div className={styles.Container}>
      <div className={styles.Left}>{left}</div>
      <div className={styles.Right}>{right}</div>
    </div>
  );
};

export default Container;





